// src/pages/Users/Inscription/components/ExtraInfoPanel.jsx

import React from "react";
import {
  FaAward,
  FaFileAlt,
  FaHashtag,
  FaStickyNote,
  FaUserGraduate,
  FaWeight,
} from "react-icons/fa";

import StepCard from "./StepCard";

function Field({ label, name, icon, children, hint, className = "" }) {
  return (
    <div className={className}>
      <label
        htmlFor={name}
        className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200"
      >
        {label}
      </label>

      <div className="relative">
        {icon ? (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            {icon}
          </span>
        ) : null}

        {children}
      </div>

      {hint ? (
        <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
          {hint}
        </p>
      ) : null}
    </div>
  );
}

const inputBase =
  "w-full rounded-2xl border border-slate-200 bg-white px-3 py-3 text-sm font-medium text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-300 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:placeholder:text-slate-500";

const inputWithIcon = `${inputBase} pl-10`;

export default function ExtraInfoPanel({
  formData,
  handleChange,
  setFormData,
  belts,
}) {
  return (
    <StepCard
      step="4"
      title="Informations complémentaires"
      icon={<FaFileAlt />}
      description="Ces informations sont utiles pour le suivi sportif, administratif et les aides éventuelles."
    >
      <div className="grid gap-5 lg:grid-cols-2">
        <Field
          label="Poids en kg"
          name="poids"
          icon={<FaWeight />}
          hint="Optionnel, utile pour les compétitions."
        >
          <input
            id="poids"
            name="poids"
            type="number"
            min="1"
            step="0.1"
            value={formData.poids}
            onChange={handleChange}
            placeholder="Ex : 32.5"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Numéro de licence"
          name="licence_number"
          icon={<FaHashtag />}
          hint="Laissez vide pour un débutant ou si le numéro est inconnu."
        >
          <input
            id="licence_number"
            name="licence_number"
            type="text"
            value={formData.licence_number}
            onChange={handleChange}
            placeholder="Numéro de licence"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Ceinture actuelle"
          name="belt_id"
          icon={<FaAward />}
          hint="Pour un débutant, sélectionnez la ceinture blanche."
        >
          <select
            id="belt_id"
            name="belt_id"
            value={formData.belt_id}
            onChange={(event) =>
              setFormData((prev) => ({
                ...prev,
                belt_id: event.target.value,
              }))
            }
            className={inputWithIcon}
          >
            <option value="">Sélectionnez une ceinture</option>
            {belts.map((belt) => (
              <option key={belt.id} value={belt.id}>
                {belt.nom}
              </option>
            ))}
          </select>
        </Field>

        <Field
          label="Date de passage"
          name="date_passage"
          icon={<FaUserGraduate />}
        >
          <input
            id="date_passage"
            name="date_passage"
            type="date"
            value={formData.date_passage}
            onChange={handleChange}
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Numéro Pass’Sport"
          name="passsport_number"
          icon={<FaHashtag />}
          hint="Optionnel. À renseigner uniquement si vous disposez d’un code Pass’Sport."
          className="lg:col-span-2"
        >
          <input
            id="passsport_number"
            name="passsport_number"
            type="text"
            value={formData.passsport_number}
            onChange={handleChange}
            placeholder="Code Pass’Sport"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="N° Pass'Club 32"
          name="passclub32_number"
          icon={<FaHashtag />}
          hint="Optionnel. À renseigner uniquement si vous disposez d’un code Pass'Club 32."
          className="lg:col-span-2"
        >
          <input
            id="passclub32_number"
            name="passclub32_number"
            type="text"
            value={formData.passclub32_number}
            onChange={handleChange}
            placeholder="Code Pass'Club 32"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Notes complémentaires"
          name="notes_adherent"
          icon={<FaStickyNote />}
          hint="Allergies, informations utiles, remarques pour les enseignants ou le secrétariat."
          className="lg:col-span-2"
        >
          <textarea
            id="notes_adherent"
            name="notes_adherent"
            value={formData.notes_adherent}
            onChange={handleChange}
            rows={5}
            placeholder="Informations complémentaires..."
            className={`${inputBase} min-h-[130px] resize-y`}
          />
        </Field>
      </div>
    </StepCard>
  );
}